import { Box, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { videoInstructionImage } from 'images/retail-energy';
import { NextPage } from 'next';
import React from 'react';
import { SEO } from 'templates/layout';
import { EnergySupplier, SuppliersList, Testimonials, VideoFullTextSection } from 'templates/retail-energy';
import { videoContractSigner, videoInstruction } from 'videos';

const useStyles = makeStyles((theme: Theme) => ({
  section: {
    padding: theme.spacing(10, 0),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(20, 0),
    },
  },
  root: {
    backgroundColor: theme.palette.switchedColors.mutedBg,
  },
}));

const Energy5: NextPage = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <SEO
        title="Retail Energy"
        description="Learn how to switch energy suppliers, find better energy companies, save on energy, buy cheaper gas & electricity - an all-in-one energy management platform."
      />
      <VideoFullTextSection
        className={classes.section}
        // simpleVideo={isDarkMode ? laptopBlack : laptopWhite}
        textSection={{
          title: { text: 'An energy management platform like no other' },
          text: 'Energy5 is a unique Energy Management platform offering residential and commercial consumers an opportunity to save big on their energy bills. Intuitive, user-friendly, and fully customizable – Energy5 gives energy consumers an all-in-one experience to facilitate greater savings and improved energy efficiency.',
          link: { href: 'https://energy5.com/', text: 'Give it a go' },
        }}
        contentSection={{
          imageSrcset: videoInstructionImage,
          videoSrcset: videoInstruction,
        }}
      />
      <EnergySupplier className={classes.section} />
      <VideoFullTextSection
        reverse
        className={classes.section}
        textSection={{
          title: { text: 'Sign Contract' },
          text: "We want the clients to take full advantage of Deregulated Markets' benefits, compare energy rates, and conclude the most profitable contracts in the shortest possible time. Except for your digital signature, the process does not imply ubiquitous bureaucracy, and the only additional step involves validation from our pricing manager.",
          link: { href: 'https://energy5.com/', text: 'Give it a go' },
        }}
        contentSection={{
          videoSrcset: videoContractSigner,
        }}
      />
      <SuppliersList />
      {/* TODO Temporarily removed page */}
      {/* <FeaturesList /> */}
      <Testimonials />
    </Box>
  );
};

export default Energy5;
